import React, { SyntheticEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { Profile } from '../../app/models/profile';
import { Button, Reveal } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

interface Props {
  profile: Profile;
}

const FollowButton: React.FC<Props> = observer(({ profile }) => {
  const { profileStore, userStore } = useStore();
  const { updateFollowing, loading } = profileStore;

  if (userStore.user?.username === profile.username) return null;

  const handleFollowing = (event: SyntheticEvent, username: string) => {
    event.preventDefault();
    profile.following
      ? updateFollowing(username, false)
      : updateFollowing(username, true);
  };

  return (
    <Reveal animated="move">
      <Reveal.Content visible style={{ width: '100%' }}>
        <Button
          fluid
          color="teal"
          content={profile.following ? 'Following' : 'Not Following'}
        />
      </Reveal.Content>
      <Reveal.Content hidden style={{ width: '100%' }}>
        <Button
          fluid
          basic
          color={profile.following ? 'red' : 'green'}
          content={profile.following ? 'Unfollow' : 'Follow'}
          loading={loading}
          onClick={(e) => handleFollowing(e, profile.username)}
        />
      </Reveal.Content>
    </Reveal>
  );
});

export { FollowButton };
